import { BrowserRouter, Routes, Route } from "react-router-dom"
import { Header } from "@/components/landing/header"
import { Hero } from "@/components/landing/hero"
import { HowItWorks } from "@/components/landing/how-it-works"
import { ForEveryone } from "@/components/landing/for-everyone"
import { Features } from "@/components/landing/features"
import { OurApproach } from "@/components/landing/our-approach"
import { Community } from "@/components/landing/community"
import { Footer } from "@/components/landing/footer"
import { DocsPage } from "@/components/docs/DocsPage"

function HomePage() {
    return (
        <main className="min-h-screen bg-cream">
            <Header />
            <Hero />
            <HowItWorks />
            <ForEveryone />
            <Features />
            <OurApproach />
            <Community />
            <Footer />
        </main>
    )
}

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/docs" element={<DocsPage />} />
            </Routes>
        </BrowserRouter>
    )
}
